// Domain url
import { domain } from './.env.js';
export const advertsPath = domain + '/uploads/adverts/';
export const apiDomain = domain + '/api/';

// Auth
export const login = 'login';
export const register = 'register';
export const logout = 'logout';

// Users
export const users =  'users/';
export const logged = users + 'logged';

// Adverts
export const adverts =  'adverts/';

// Clients
export const clients =  'clients/';

// Android app
export const versions =  'android/';

// Clients
export const companies =  'companies/';

